import PropTypes from 'prop-types'
import { useState } from 'react'
import { useDispatch } from 'react-redux'

import { acGetAllPlanGroups, acDeletePlanGroup } from '../../../store/actions'
import { ERRORS } from '../../../store/constants'
import { ConfirmModal, Snackbar } from '../../default'

/**
 * @description Renders a modal component for deleting a plan group.
 *
 * @author Maria Eduarda Franke
 * @param {boolean} props.open - Determines if the modal is open or not.
 * @param {function} props.onClose - The function to close the modal.
 * @param {Object} props.selectedPlanGroup - The selected plan group to be deleted.
 * @returns {JSX.Element} The rendered DeletePlanGroupModal component.
 */
const DeletePlanGroupModal = ({ open, onClose, selectedPlanGroup }) => {

    const dispatch = useDispatch()

    const [snackbarData, setSnackbarData] = useState({ open: false, severity: 'success', message: '' })

    const handleSnackbarClose = (_, reason) => {
        if (reason === 'clickaway') return
        setSnackbarData({ ...snackbarData, open: false })
    }

    const onConfirm = () => {
        dispatch(acDeletePlanGroup(selectedPlanGroup.plan_group_id))
            .then(() => {
                onClose()
                setSnackbarData({ open: true, severity: 'success', message: `Grupo de planos #${selectedPlanGroup.plan_group_id} excluído com sucesso!` })
                dispatch(acGetAllPlanGroups())
                    .catch(error => console.error(error))
            })
            .catch(err => {
                console.error(err)
                onClose()
                setSnackbarData({ open: true, severity: 'error', message: `Não foi possível excluir o grupo de planos #${selectedPlanGroup.plan_group_id}. ${ERRORS[err.description]}` })
            })
    }

    return (
        <>
            <ConfirmModal
                open={open} onClose={onClose} onConfirm={onConfirm}
                title='Excluir Grupo de Planos'
                id={selectedPlanGroup?.plan_group_id}
                description={`Você tem certeza que deseja excluir o "${selectedPlanGroup?.name}" ?`}
            />
            <Snackbar
                open={snackbarData.open}
                onClose={handleSnackbarClose}
                severity={snackbarData.severity}
                message={snackbarData.message}
                vertical='bottom'
                horizontal='right'
                variant='filled'
                sx={{ mt: 1 }}
            />
        </>
    )

}

DeletePlanGroupModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    selectedPlanGroup: PropTypes.object
}

export default DeletePlanGroupModal